module.exports = __webpack_public_path__ + "static/omega_g5-72db664c7cf8ed79800c61d54c90b72d.jpg";